import { FC } from 'react'
import { Box, Typography } from '@mui/material'
import { CostDistributionItemWrapper } from './costDistributionItem.styles'
import CostDistributionChip from './CostDistributionChip'

interface Props {
  item: any
}

const CostDistributionItem: FC<Props> = ({ item }) => {
  return (
    <CostDistributionItemWrapper className="cost-distribution-item-wrapper">
      <Box className="item-left">
        <Typography className="cell">{item.cell}</Typography>
        {item.isCurrentArea && <CostDistributionChip />}
      </Box>
      <Box className="item-right">
        <Typography className="percent-value">{item.percentValue}</Typography>
        <Typography className="cost">{Number(item.cost ?? 0).toLocaleString()}</Typography>
      </Box>
    </CostDistributionItemWrapper>
  )
}

export default CostDistributionItem
